module.exports = __webpack_public_path__ + "d3c1b514db3763d3ccc9bf766d9af38f.png";